import { render } from "./IngenieriaDeProceso.vue?vue&type=template&id=60d72543&scoped=true"
import script from "./IngenieriaDeProceso.vue?vue&type=script&lang=js"
export * from "./IngenieriaDeProceso.vue?vue&type=script&lang=js"

import "./IngenieriaDeProceso.vue?vue&type=style&index=0&id=60d72543&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d72543"]])

export default __exports__